export var EXACT_RESPONSE = 'exactResponse';
export var MARGIN_OF_ERROR = 'marginOfError';
export var PRECISE_RESPONSE = 'preciseResponse';
export var WITHIN_A_RANGE = 'withinARange';

// Margin of error
export var ABSOLUTE = 'absolute';
export var PERCENT = 'percent';

// Precise response
export var DECIMALS = 'decimals';
export var SIGNIFICANT_DIGITS = 'significantDigits';